import { API } from 'aws-amplify';
import { z } from 'zod';

import { HubSpotUser, hubspotUserSchema } from '../schemas/HubSpotUserSchema';

export const listUsers = async ():Promise<HubSpotUser[]> => {
  const response = await API.get('party', '/hubspot/users', {});

  const parsed = z.array(hubspotUserSchema).safeParse(response);
  if (!parsed.success) {
    throw new Error(`Failed to fetch HubSpot users: ${parsed.error}`);
  }

  return parsed.data;
}
